// extracted by mini-css-extract-plugin
export var description = "hx_c";
export var iconContainer = "hx_fM";
export var label = "hx_bj";
export var navItemContainer = "hx_qw";
export var textContainer = "hx_dD";